import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuthProvider } from '../../auth/hooks/auth-provider';
import { useProject } from '../../hooks/useProject';
import { UserType } from '../../models/UserType';
import { ProjectStatus } from '../../models/Project';

interface ProjectEditProtectionProps {
  children: React.ReactNode;
}

const ProjectEditProtection: React.FC<ProjectEditProtectionProps> = ({ children }) => {
  const { id } = useParams<{ id: string }>();
  const projectId = parseInt(id || '0');
  const { user } = useAuthProvider();
  const { data: project, isLoading, error } = useProject(projectId);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !project) {
    return <Navigate to="/projects" replace />;
  }

  // If user is a client and project is submitted, redirect to project details
  if (user.type === UserType.Client && project.status !== ProjectStatus.Draft) {
    return <Navigate to={`/projects/${projectId}`} replace />;
  }

  return <>{children}</>;
};

export default ProjectEditProtection;